<template>
  <div id="page-wrap">
    <div class="container-fluid group-wrap clearfix">
      <div class="container">
        <div class="group-header">
          <div class="personal-avator">
            <img :src="user.avatar" />
          </div>
          <div class="name">
            <h1>{{user.name}}</h1>
            <p>
              <b>个人简介：</b>
              {{user.profile || '暂无简介'}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="panel">
        <div class="panel-heading">
          <h4 class="panel-title">TA的群组</h4>
        </div>
        <div class="panel-body">
          <div class="row personal-member">
            <div
              class="col-md-3 col-sm-4 col-xs-6"
              v-for="group in groups"
              :key="group.group_number"
            >
              <div class="userlist">
                <router-link
                  class="user-avator"
                  :src="group.group_logo"
                  :to="{name:'group',params:{groupNumber:group.group_number}}"
                  tag="img"
                />
                <div class="name">
                  <router-link
                    :to="{name:'group',params:{groupNumber:group.group_number}}"
                    tag="h1"
                  >{{group.group_name}}</router-link>
                  <div class="info">
                    <router-link
                      :to="{name:'groupMember',params:{groupNumber:group.group_number}}"
                      tag="span"
                    >{{group.group_memeber_count}}成员</router-link>
                    <router-link
                      :to="{name:'groupDisk',params:{groupNumber:group.group_number}}"
                      tag="span"
                    >{{group.group_file_count}}资源</router-link>
                    <router-link
                      :to="{name:'groupTopic',params:{groupNumber:group.group_number}}"
                      tag="span"
                    >{{group.group_topic_count}}话题</router-link>
                    <span>【{{group.group_category_name}}】</span>
                  </div>
                  <div class="member">
                    <ul>
                      <router-link
                        :to="{name:'user',params:{userNumber:member.group_member_number}}"
                        tag="li"
                        v-for="member in group.group_member_list"
                        :key="member.group_member_number"
                      >
                        <img
                          :src="member.group_member_avatar"
                          :title="member.group_member_realname"
                        />
                      </router-link>
                      <router-link
                        :to="{name:'groupMember',params:{groupNumber:group.group_number}}"
                        tag="li"
                      >
                        <i class="ti-more" title="查看更多成员"></i>
                      </router-link>
                    </ul>
                    <span>{{group.group_created_date|dateFilter}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { publicUserinfo } from "@/api/user/user";
import { publicGroups } from "@/api/group/group";
export default {
  name: "User",
  data() {
    return {
      userNumber: null,
      user: {
        profile: "",
        name: "",
        avatar: ""
      },
      groups: []
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.userNumber = to.params.userNumber;
    this.publicUserinfo();
    next();
  },
  created() {
    this.userNumber = this.$route.params.userNumber;
    this.$store.commit("SET_THEME", "个人主页");
    this.publicUserinfo();
  },
  filters: {
    dateFilter(date) {
      return date.substr(0, 10);
    }
  },
  methods: {
    goToGroup(groupNumber) {
      let routeUrl = this.$router.resolve({
        name: "group",
        params: { groupNumber: groupNumber }
      });
      window.open(routeUrl.href, "_blank");
    },
    publicUserinfo() {
      publicUserinfo(this.userNumber)
        .then(res => {
          if (res.status_code === 200) {
            this.user = res.entity;
            this.getPublicGroups();
          } else if (res.status_code === 410) {
            this.$message({
              type: "error",
              message: res.message
            });
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err
          });
        });
    },
    getPublicGroups() {
      publicGroups({
        user_number: this.userNumber
      })
        .then(res => {
          if (res.status_code === 200) {
            this.groups = res.entity.datas;
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err
          });
        });
    }
  }
};
</script>

<style scoped>
/*个人主页*/
.personal-avator {
  width: 60px;
  height: 60px;
  background: #fff;
  float: left;
}
.personal-avator ~ .name {
  padding-left: 80px;
  width: 100%;
}
.personal-avator ~ .name p {
  margin-top: 5px;
}
.personal-avator ~ .name p b {
  font-weight: normal;
}
.personal-avator img {
  width: 100%;
  height: 100%;
}
.personal-member .userlist {
  width: 100%;
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;
  transition: 0.3s;
  position: relative;
}
.personal-member .userlist .user-avator {
  width: 100%;
  margin: 0 auto;
  transition: 0.3s;
  background: #333;
  background-size: 100% auto;
  background-position: center;
}
.userlist .user-avator:hover,
.userlist .name h1:hover,
.userlist .name .member ul li:last-child:hover,
.userlist .name .info span:not(:last-child):hover {
  color: #006adf;
  cursor: pointer;
}
.userlist .name .member ul li img:hover {
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.personal-member .userlist .user-avator img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.personal-member .userlist .name {
  padding-top: 20px;
}
.personal-member .userlist .name h1 {
  font-size: 14px;
  margin-bottom: 20px;
  font-weight: bold;
}
.personal-member .userlist .name p {
  font-size: 12px;
  color: #999;
}
.personal-member .userlist:hover {
  box-shadow: rgba(0, 0, 0, 0.4) 0 5px 10px;
  transition: 0.3s;
}
.personal-member .userlist:hover .user-avator {
  background-size: 120% auto;
  transition: 0.3s;
}

.personal-member .userlist .info span:nth-of-type(2) {
  margin: 0 5px;
}
.personal-member .userlist .info span:last-child {
  float: right;
}
.personal-member .userlist .member {
  height: 30px;
  margin-top: 15px;
}
.personal-member .userlist .member li {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: #fff solid 2px;
  float: left;
  margin-left: -10px;
  background: #eee;
}
.personal-member .userlist .member li img {
  width: 26px;
  height: 26px;
  border-radius: 50%;
}
.personal-member .userlist .member span {
  float: right;
  color: #999;
  line-height: 30px;
}
.personal-member .userlist .member li:first-child {
  margin-left: 0;
}
.personal-member .userlist .member li:last-child {
  text-align: center;
  line-height: 30px;
  background: #eee;
}
</style>